import React, { SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";
import { Severity } from "node-library/dist/constants";
import { useSnackbar } from "../../../common-components/toast/showToastMessage";
import { GreenTickIcon } from "../../../common-components/toast/successIcons";
import { Card, Divider } from "@mui/material";
import {
	CustomCheckbox,
	CustomPriceInput,
	CustomTextInput,
} from "../../../common-components/inputs";
import {
	BlueButton,
	CustomIconButton,
} from "../../../common-components/button";
import KeyboardArrowLeftIconRounded from "@mui/icons-material/KeyboardArrowLeft";
import { TruckIcon } from "../../../common-components/svgIcons";

interface Props {
	currency: string;
	handlingFee: number;
	shippingFee: number;
	setHandlingFee: React.Dispatch<SetStateAction<number>>;
	setShippingFee: React.Dispatch<SetStateAction<number>>;
	shippingDescription: string;
	setShippingDescription: React.Dispatch<SetStateAction<string>>;
	handlingDescription: string;
	setHandlingDescription: React.Dispatch<SetStateAction<string>>;
	fullServiceShippingSolution: boolean;
	setFullServiceShippingSolution: React.Dispatch<SetStateAction<boolean>>;
	goBackToAddItemPage: () => void;
	setUnsavedChanges: React.Dispatch<SetStateAction<boolean>>;
}

export default function ShippingHandlingFee(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();
	const { currency, goBackToAddItemPage } = props;

	const setUnsavedChanges = props.setUnsavedChanges;
	const [handlingFee, setHandlingFee] = useState<number>(props.handlingFee);
	const [shippingFee, setShippingFee] = useState<number>(props.shippingFee);
	const [shippingDescription, setShippingDescription] = useState<string>(
		props.shippingDescription
	);
	const [handlingDescription, setHandlingDescription] = useState<string>(
		props.handlingDescription
	);
	const [fullServiceShippingSolution, setFullSerivceShippingSolution] =
		useState<boolean>(props.fullServiceShippingSolution || false);

	function handleSubmitHandlingShipping() {
		props.setHandlingFee(handlingFee);
		props.setShippingFee(shippingFee);
		props.setFullServiceShippingSolution(fullServiceShippingSolution);
		props.setShippingDescription(shippingDescription);
		goBackToAddItemPage();
		openSnackbar(
			translation("ChangeUpdated"),
			Severity.SUCCESS,
			undefined,
			<GreenTickIcon />
		);
	}
	return (
		<div
			id="shipping-handling-body"
			className="page-content-padding"
			style={{ display: "grid", rowGap: "16px" }}
		>
			<div className="center-align-with-gap">
				<CustomIconButton
					id="back-to-order-client-details-button"
					size="small"
					onClick={() => {
						props.goBackToAddItemPage();
					}}
					icon={<KeyboardArrowLeftIconRounded />}
				></CustomIconButton>
			</div>
			{
				<Card id="item-info-content" className="card-equal-padding">
					{/* <div id="new-sample-header">
				<StepsBar
					items={headerItems}
					currentItem={currentPageIndex - 1}
					setCurrentItem={setCurrentPageIndex}
					icons={[]}
				></StepsBar>
			</div>
			<hr style={{ width: "100%", color: NeutralColor.NEUTRAL_GREY_200 }}></hr> */}
					<div className="item-info-session">
						<div className="item-info-left-session">
							<div className="center-align-with-gap">
								<TruckIcon></TruckIcon>
								<span className="typography-heading-04 typography-bold">
									{translation("HandlingAndShpping")}
								</span>
							</div>
						</div>
						<div
							style={{
								flex: "6",
								display: "flex",
								flexDirection: "column",
								gap: "16px",
							}}
						>
							<CustomPriceInput
								id="handling-fee-input"
								label={`${translation("HandlingFee")}`}
								value={handlingFee}
								currency={currency}
								setValue={(value) => {
									setHandlingFee(value);
									setUnsavedChanges(true);
								}}
								required
							/>
							<CustomTextInput
								id="handling-description-input"
								label={translation("Description")}
								value={handlingDescription}
								setValue={(value) => {
									setHandlingDescription(value);
									setUnsavedChanges(true);
								}}
								isTextArea
							/>
							<Divider sx={{ borderStyle: "dashed" }} />
							<CustomPriceInput
								id="shipping-fee-input"
								label={`${translation("ShippingFee")}`}
								value={shippingFee}
								currency={currency}
								setValue={(value) => {
									setShippingFee(value);
									setUnsavedChanges(true);
								}}
								required
							/>
							<CustomCheckbox
								className={`even-space-flex-item`}
								label={translation("FullServiceShippingSolution")}
								labelClassName={"typography-body-01"}
								checked={fullServiceShippingSolution}
								setChecked={setFullSerivceShippingSolution}
							/>

							<CustomTextInput
								id="shipping-description-input"
								label={translation("Description")}
								value={shippingDescription}
								setValue={(value) => {
									setShippingDescription(value);
									setUnsavedChanges(true);
								}}
								isTextArea
							/>

							<BlueButton
								id="save-handling-shipping-fee-to-order-button"
								children={translation("SaveToOrder")}
								size={"flex"}
								// disabled={loading}
								onClick={() => {
									handleSubmitHandlingShipping();
								}}
							/>
						</div>
					</div>
				</Card>
			}
		</div>
	);
}
